import { Component, input, inject, effect, computed } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButton } from '@angular/material/button';
import { ToolchainService } from '../../services/api-services/toolchains/toolchain.service';
import { ToolchainRegistrationDialogComponent } from '../admin-area-list/toolchain-registration-dialog/toolchain-registration-dialog.component';

@Component({
  selector: 'app-toolchain-config',
  templateUrl: './toolchain-config.component.html',
  styleUrls: ['./toolchain-config.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    MatButton,
  ],
})
export class ToolchainConfigComponent {
  /** Inject services. */
  private readonly dialogRef = inject(MatDialog);
  private readonly toolchainService = inject(ToolchainService);

  readonly toolchainId = input<number | undefined>(undefined);

  readonly toolchains = this.toolchainService.getToolchainDescriptionsAdmin();

  readonly toolchain = computed(() => {
    const toolchains = this.toolchains.value();
    return toolchains?.find(toolchain => toolchain.toolchainId === this.toolchainId());
  });

  toolchainForm = new FormGroup({
    toolchainId: new FormControl(''),
    toolchainName: new FormControl(''),
    toolchainDisplayName: new FormControl(''),
    toolchainDescription: new FormControl(''),
    author: new FormControl(''),
    project: new FormControl(''),
    version: new FormControl(''),
  });

  constructor() {
    effect(() => {
      const toolchain = this.toolchain();
      if (!toolchain) return;
      this.toolchainForm.controls['toolchainId'].setValue(toolchain.toolchainId.toString());
      this.toolchainForm.controls['toolchainName'].setValue(toolchain.name);
      this.toolchainForm.controls['toolchainDescription'].setValue(toolchain.description);
      this.toolchainForm.controls['author'].setValue(toolchain.author);
      this.toolchainForm.controls['project'].setValue(toolchain.project);
      this.toolchainForm.controls['version'].setValue(toolchain.toolchainVersion);
      this.toolchainForm.controls['toolchainDisplayName'].setValue(toolchain.displayName);
    });
  }

  openRegistrations() {
    this.dialogRef.open(ToolchainRegistrationDialogComponent, {
      minWidth: '24rem',
      data: this.toolchain,
    });
  }
}
